const Excel = () => {
  return (
    <svg
      width="15"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4871 5.47768V18.7118C14.4871 19.4244 13.9115 20 13.1989 20H1.28818C0.575568 20 0 19.4244 0 18.7118V1.28818C0 0.575568 0.575568 0 1.28818 0H9.0094L14.4871 5.47768Z"
        fill="#23A566"
      />
      <path
        d="M10.4111 9.95703H4.07591C3.84882 9.95703 3.66479 10.1411 3.66479 10.3682V15.885C3.66479 16.1121 3.84882 16.2961 4.07591 16.2961H10.415C10.6421 16.2961 10.8261 16.1121 10.8261 15.885V10.3721C10.8222 10.145 10.6382 9.95703 10.4111 9.95703ZM4.48703 12.6039H6.83238V13.6493H4.48703V12.6039ZM7.65461 12.6039H9.99996V13.6493H7.65461V12.6039ZM9.99996 11.7816H7.65461V10.7832H9.99996V11.7816ZM6.83238 10.7832V11.7816H4.48703V10.7832H6.83238ZM4.48703 14.4754H6.83238V15.4739H4.48703V14.4754ZM7.65461 15.4739V14.4754H9.99996V15.4739H7.65461Z"
        fill="white"
      />
      <path
        opacity="0.19"
        d="M9.74548 5.27655L14.4871 9.11758V5.51147L11.7972 3.94922L9.74548 5.27655Z"
        fill="black"
      />
      <path
        d="M14.4871 5.47768H10.2976C9.58497 5.47768 9.0094 4.90211 9.0094 4.18951V0L14.4871 5.47768Z"
        fill="#8ED1B1"
      />
    </svg>
  );
};

export default Excel;
